export default __webpack_public_path__ + "static/media/reformer-img.b4f2b7a3.png";